import { createRoot } from "react-dom/client";
import App from "./app/App.tsx";
import { installChunkErrorReloader } from "./utils/lazyWithRetry";
import { initUiDensity } from "./lib/uiDensity";
import { installTouchKeyboardDismiss } from "./utils/touchKeyboardDismiss";
import { installIPadAutoFocusGuard } from "./utils/ipadAutoFocusGuard";
import { snapshotClientIntegrity } from "./utils/clientIntegrity";
import { registerServiceWorker } from "./pwa/registerServiceWorker";

import "./styles/font-style.css";
import "./styles/main.scss";
import "./styles/variables.css";
import "./styles/index.css";
import "./styles/ui-density.css";

// Probe fetch/XHR natives BEFORE anything else runs — see utils/clientIntegrity.ts.
snapshotClientIntegrity();
installChunkErrorReloader();
installTouchKeyboardDismiss();
installIPadAutoFocusGuard();

// index.html already pinned the root font-size at full size inline (the
// "comfortable" default — no flash); this attaches the resize listener and
// lets a DB-saved "auto"/"compact" preference take over once it hydrates.
initUiDensity();

// Installable app: /sw.js (production only; src/pwa).
registerServiceWorker();

createRoot(document.getElementById("root")!).render(<App />);
